import React, { useState, useEffect } from 'react';
import Input from '../../../../Elements/Input';
import Button from '../../../../Elements/Button';
import Table from '../../../../Table';
import { useDebounce } from '../../../../../hooks';
import config from '../../../../../config/config';
import './Winners.scss';

const Winners = ({winnersList}) => {
  const headers = Object.keys(winnersList[0]).map(key => config.nftTableHeaders[key] ?? key);
  const sortedList = [...new Set(winnersList
    .map(item => item["raffle_id"])
    .sort((a, b) => b - a))];

  const [currentPage, setCurrentPage] = useState(0);
  const [searchValue, setSearchValue] = useState();
  const debounceSearchValue = useDebounce(searchValue, 1000);
  const [currentRaffleDate, setCurrentRaffleDate] = useState(null);
  const [isShowAll, setIsShowAll] = useState(false);
  const isLoading = searchValue !== debounceSearchValue;
  
  const filteredData = winnersList
    .filter(row => 
      debounceSearchValue ? row["eth_address"]?.includes(debounceSearchValue) || row["coti_address"]?.includes(debounceSearchValue) : 
      row["raffle_id"] === currentRaffleDate
    ).slice(0, !searchValue && !isShowAll ? 10 : winnersList.length);

  const nextDate = () => {
    if(currentPage > 0) {
      setCurrentPage(prev => prev -1);
    }
  }
  
  const prevDate = () => {
    if(currentPage < sortedList.length-1) {
      setCurrentPage(prev => prev +1);
    }
  }

  const toggleShowAll = () => {
    if(!!debounceSearchValue) {
      setSearchValue("");
    } else {
      setIsShowAll(!isShowAll);
    }
  }

  useEffect(() => {
    if(currentPage >= 0 && currentPage < sortedList.length) {
        setCurrentRaffleDate(sortedList[currentPage]);
    }
    //eslint-disable-next-line
  }, [currentPage])

  return <div className="winners-component">
      <h2>Winners of the week</h2>
      <SearchBox searchValue={searchValue} setSearchValue={setSearchValue} />
      {!searchValue && <DatePaginator 
        nextDisabled={currentPage-1 < 0} 
        prevDisabled={currentPage+1 > sortedList.length-1}
        currentDate={currentRaffleDate} 
        prevDate={prevDate} 
        nextDate={nextDate} 
      /> }

      <Table isLoading={isLoading} data={filteredData} headers={headers} types={config.tableRowOptionTypes} />
      <ShowAll total={winnersList.length} onClick={toggleShowAll} isSearch={!!debounceSearchValue} isShowAll={isShowAll} />
  </div>
};

const SearchBox = ({searchValue, setSearchValue}) => {
  return (
    <div className="search-box-container">
      <Input isSkew type="text" placeholder="Please enter your ERC-20 address or COTI Address" value={searchValue} onChange={({target: { value }}) => setSearchValue(value)}/>
    </div>
  )
}

const DatePaginator = ({currentDate, prevDate, prevDisabled, nextDate, nextDisabled}) => {
  return (
    <div className="date-paginator-component">
      <Button className="date-paginator-component__arrow" onClick={prevDate} disabled={prevDisabled}><img src={require('../../../../../images/icons/left-arrow.svg').default} alt="prev" /></Button>
      <span>{currentDate}</span>
      <Button className="date-paginator-component__arrow" onClick={nextDate} disabled={nextDisabled}><img src={require('../../../../../images/icons/right-arrow.svg').default} alt="prev" /></Button>
    </div>
  )
}

const ShowAll = ({total = 0, isShowAll, isSearch, onClick}) => {
  return (
    <div className="show-all-component">
      <span>A total of {total} winners</span>
      <Button buttonText={isSearch ? "CLEAR" : !isShowAll ? 'SHOW ALL' : 'SHOW LESS'} onClick={onClick} />
    </div>
  )
}

export default Winners;
